export default __webpack_public_path__ + "static/media/whatsappSlide7.6e5c6541.svg";